<template>
  <v-container>
    <!--//@*/*
    //    *RPD  Nbirs test App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- SECTION 2 -->

    <!-- Question1 -->
    <v-row id="s2q1" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 1</v-card-title>
          <v-card-subtitle class="pb-0"
            >Bill Brown reports a residential burglary. There is no known
            suspect at this time.</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q1" class="ml-8 mt-0">
            <v-radio
              label="Suspect is listed as ;UNKNOWN"
              value="s2q1-1"
            ></v-radio>
            <v-radio label="Suspect is listed as UNKNOWN" value="s2q1-2">
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question2 -->
    <v-row id="s2q2" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 2</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing the above residential burglary, the suspect in the
            burglary is now identified as Max Smart. On ARS Supp
            Matching....</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q2" class="ml-8 mt-0">
            <v-radio label="Add suspect Max Smart." value="s2q2-1"></v-radio>
            <v-radio
              label="Choose the 'update all person' option for the UNKNOWN suspect, so that Max Smart shows as the one and only suspect."
              value="s2q2-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 3 -->
    <v-row id="s2q3" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 3</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing the same residential burglary, Max Smart is now
            arrested. On ARS Supp Matching...</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q3" class="ml-8 mt-0">
            <v-radio
              label="Choose the 'Add' option for Max Smart to show him as an arrested person."
              value="s2q3-1"
            ></v-radio>
            <v-radio
              label="Choose the 'Update all person' option Sus Max Smart so that now there is an arrest and no suspects are listed."
              value="s2q3-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 4 -->
    <v-row id="s2q4" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 4</v-card-title>
          <v-card-subtitle class="pb-0">
            Referencing the same residential burglary. When is booking and
            transferring of the offense completed?</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q4" class="ml-8 mt-0">
            <v-radio label="After supplement matching" value="s2q4-1"></v-radio>
            <v-radio label="It doesn't need to be done." value="s2q4-2">
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 5 -->
    <v-row id="s2q5" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 5</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing this same residential burglary. What is the last thing
            that needs to be done to complete the processing of this
            case?</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q5" class="ml-8 mt-0">
            <v-radio
              label="Booking and transferring the arrest."
              value="s2q5-1"
            ></v-radio>
            <v-radio
              label="Validating the case after booking and transferring the arrest."
              value="s2q5-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 6 -->
    <v-row id="s2q6" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 6</v-card-title>
          <v-card-subtitle class="pb-0"
            >Betty Ward returned from a 2 week trip and discovered her home had
            been broken into and compiled a list of items that were stolen.
            Among the items stolen was a laptop that she didn't have the serial
            number for. On the original report the item was listed as STN D
            LAPTOP, with a value of $1000. 1 week later Betty called and advised
            the laptop was a Mac and she had the serial number. On Supp one
            Betty was listed as the Reporting party. On ARS Supp
            Matching.....</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q6" class="ml-8 mt-0">
            <v-radio
              label="Add the Mac laptop as new property. Choose the 'Update All Person' choice for Betty."
              value="s2q6-1"
            ></v-radio>
            <v-radio
              label="Choose the 'Replace' option for the laptop, add Betty as a reporting party."
              value="s2q6-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 7 -->
    <v-row id="s2q7" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 7</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing Betty's burglary. 2 weeks later Betty discovered a
            Canon camera that was in her closet had been destroyed. In this
            supplement (Supp 2) Betty is listed as a victim. The DOP offense is
            added on the Offense tab. On ARS Supp Matching....</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q7" class="ml-8 mt-0 pr-2">
            <v-radio
              label="Choose 'Update all Person' for Betty where her involvement type is 'VIC', add the damaged camera as new
property. Manually enter the offense into RMS."
              value="s2q7-1"
            ></v-radio>
            <v-radio
              label="Add Betty as a VIC, add the camera as new property, don't worry about the NOC."
              value="s2q7-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 8 -->
    <v-row id="s2q8" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 8</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing Betty's burglary. A week later a neighbor remembers
            seeing a white male approximately 25-30 years old, knocking on doors
            around the neighborhood. This neighbor advised she saw him at
            Betty's house a couple of days, but didn't think anything of it.
            Betty calls the front desk to give this new information, and states
            she believes he may have been casing her house. Supp 3 lists Betty
            as the VIC, and enters the suspect information given. On ARS Supp
            Matching...</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q8" class="ml-8 mt-0">
            <v-radio
              label="Choose 'Update all Person' for Betty where her involvement type is 'VIC', choose 'Update all Person' option for the
Unk suspect"
              value="s2q8-1"
            ></v-radio>
            <v-radio
              label="'Add' Betty as a Vic, 'Add' suspect information"
              value="s2q8-2"
            ></v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 9 -->
    <v-row id="s2q9" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 9</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing Betty's burglary. A week later WMA is seen on video
            pawning Betty's laptop. The pawn shop gives PD the information on
            the male who pawned this property. His name is Pete Beck and he is
            32 years old. Supp 4 is created for this case listing Pete Beck as
            the suspect. On ARS Supp Matching.....</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q9" class="ml-8 mt-0">
            <v-radio
              label="'Add' Pete Beck as a new suspect."
              value="s2q9-1"
            ></v-radio>
            <v-radio
              label="Choose the 'Update all Person' option for the unk suspect. On RMS manually correct Pete's age."
              value="s2q9-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 10 -->
    <v-row id="s2q10" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 10</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing Betty's burglary. 2 weeks later Pete is arrested
            pawning more stolen property. Several of Betty's items are returned
            to her. Supp 5 shows Pete arrested, and lists the recovered
            property. On ARS Supp Matching...</v-card-subtitle
          >

          <v-radio-group v-model="local_s2answers.s2q10" class="ml-8 mt-0 pr-2">
            <v-radio
              label="'Add' Pete as arrested. Choose the 'replace' option for the stolen items that are now recovered. Book and transfer
the arrest, validate the report."
              value="s2q10-1"
            ></v-radio>
            <v-radio
              label="Choose the 'Update All Person' option for Pete Beck as a suspect. 'Add' the recovered property as new property.
Book and transfer the arrest, validate the report."
              value="s2q10-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 11 -->
    <v-row id="s2q11" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 11</v-card-title>
          <v-card-subtitle class="pb-0"
            >Donnie Brown is stabbed multiple times. He is brought to the
            hospital, he refuses to talk to the police. HIs injuries are life
            threatening. The suspect is listed as Unk. The next day Donnie's
            father (Ed) calls the police to advise that Donnie has been doing
            meth and Ed believes Donnie may have been stabbed in a deal that had
            gone wrong. Lab tests verified that Donnie had meth in his system.
            Ed only knows a couple of the monikers of people Donnie hangs out
            with. "Ghost" is described as an extremely thin WMA about 6 ft tall,
            bald and approximately 40 years of age. "Blade" is described as an
            AMA, about 5'8", 25 yoa with very short black hair. Supp 1 is
            created with the new information. On ARS Supp
            Matching.....</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q11" class="ml-8 mt-0 pr-2">
            <v-radio
              label="Choose 'Update All Option' for the unk suspect listed. 'Add' the second suspect. Validate"
              value="s2q11-1"
            ></v-radio>
            <v-radio
              label="'Add' both suspects. Validate report."
              value="s2q11-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 12 -->
    <v-row id="s2q12" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 12</v-card-title>
          <v-card-subtitle class="pb-0">
            Referencing Donnie Brown. Ghost is identified by the SET team as
            Marshall Johnson, and Blade is identified as Jim Li. There are
            active FTA felony warrants for both Marshall and Jim on Drug
            charges. Supp 2 is created with the new information. On ARS Supp
            Matching...</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q12" class="ml-8 mt-0 pr-2">
            <v-radio
              label="'Add' Marshall Johnson and Jim Li as new suspects."
              value="s2q12-1"
            ></v-radio>
            <v-radio
              label="Choose 'Update all person' for suspect Ghost showing him as Marshall Johnson. Choose 'Update All Person' for
suspect Blade showing him as Jim Li. Correct ages on RMS. Validate report."
              value="s2q12-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 13 -->
    <v-row id="s2q13" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 13</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing Donnie Brown: 2 months after Marshall and Jim are
            identified, Tina Smith is arrested for prostitution. A search of her
            purse finds 2 grams of crystal meth. Tina tells police she got the
            drugs from "Ghost" and was being forced to prostitute herself by
            Ghost. She also knows Ghost and Blade had stabbed a man
            approximately 2 to 3 weeks ago during a drug buy, and this man is
            still hospitalized. Which of the following are
            correct.</v-card-subtitle
          >
          <v-card-subtitle class="mb-1">
            <p class="pl-3 text-sm-caption mb-0">
              (a) Tina is arrested on the same case number as Donnie's stabbing.
            </p>
            <p class="pl-3 text-sm-caption mb-0">
              (b) Tina is arrested on a new case number. The information Tina
              has about Ghost and Blade stabbing Donnie is added to Donnie's
              report.
            </p>
            <p class="pl-3 text-sm-caption mb-1">
              (c) Tina is listed a victim of trafficking on the same case number
              as her prostitution arrest.
            </p>
            <p class="pl-3 text-sm-caption mb-1">
              (d)A new case number is drawn listing Tina as the victim of
              Trafficking, and Ghost as the suspect.
            </p>
          </v-card-subtitle>

          <v-radio-group v-model="local_s2answers.s2q13" class="ml-8 mt-0">
            <v-radio label="A & C" value="s2q13-1"> </v-radio>
            <v-radio label="A & D" value="s2q13-2"> </v-radio>
            <v-radio label="B & C" value="s2q13-3"> </v-radio>
            <v-radio label="B & D" value="s2q13-4"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 14 -->
    <v-row id="s2q14" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 14</v-card-title>
          <v-card-subtitle class="pb-0"
            >Referencing Donnie Brown. 2 weeks after Tina was arrested, Ghost
            and Blade are arrested during a drug buy sting. They have current
            charges for possession and sales of controlled substances. They are
            also arrested on their warrants. Which of the below is
            correct.</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q14" class="ml-8 mt-0">
            <v-radio
              label="A case number is drawn for Ghost's and Blade's arrest. They are booked on the warrants on this case number."
              value="s2q14-1"
            ></v-radio>
            <v-radio
              label="A case number is drawn for Ghost's and Blade's current charges. A new case number is drawn for the warrants."
              value="s2q14-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 15 -->
    <v-row id="s2q15" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 15</v-card-title>
          <v-card-subtitle class="pb-0"
            >On a traffic accident case one of the drivers is charged and
            arrested with a DUI. The DUI charge shows up on Supp 1, not the
            original. Describe the steps you would take to correctly code this
            case for NIBRS reporting.:</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q15" class="ml-8 mt-0">
            <v-radio
              label="F/T the arrest, Book & Transfer the charges."
              value="s2q15-1"
            ></v-radio>
            <v-radio
              label="F/T the arrest, on the RMS side change the incident type to DUI, and manually add the NOC code to the offense tab. Book & Transfer the charges.  Validate the report."
              value="s2q15-2"
            >
            </v-radio>
            <v-radio
              label="FF/T the arrest, on the RMS side change the incident type to DUI, and manually add the NOC code to the offense tab. Manually add the correct IBRS code to the victim of the crime.  Book & transfer the charges. Validate the report."
              value="s2q15-3"
            ></v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 16 -->
    <v-row id="s2q16" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 16</v-card-title>
          <v-card-subtitle class="pb-0"
            >The Validation response "IBRS Control Not On File" is received
            when: Please highlight the correct answer.</v-card-subtitle
          >
          <v-radio-group v-model="local_s2answers.s2q16" class="ml-8 mt-0">
            <v-radio
              label="The report is a traffic accident."
              value="s2q16-1"
            ></v-radio>
            <v-radio
              label="The report is a not NIBRS reportable offense."
              value="s2q16-2"
            >
            </v-radio>
            <v-radio
              label="The report is a Courtesy report."
              value="s2q16-3"
            ></v-radio>
            <v-radio
              label="The report was initiated prior to 8/1/2019."
              value="s2q16-4"
            >
            </v-radio>
            <v-radio
              label="The report was a Courtesy report."
              value="s2q16-5"
            ></v-radio>
            <v-radio label="All of the above." value="s2q16-6"> </v-radio>
            <v-radio label="None of the above." value="s2q16-7"></v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100%;
    max-width: 768px;
    height: auto;
    padding-top: 65px;
    margin: auto;
  }

  #home-container .v-card__subtitle {
    color: #5c5c5c;
  }

  #home-container a {
    color: #1565c0;
  }

  #home-container a.temp-2-nav {
    color: aliceblue;
  }

  .fixWidth {
    width: 100%;
  }

  .fixWidth_header {
    width: 100%;
  }

  .rad1 {
    background-color: white;
    height: 250px;
    width: 80%;
  }

  .alice {
    color: aliceblue;
  }

  .v-card__subtitle.reference {
    color: blue;
  }

  #sworn_test_section1 .top-card,
  #sworn_test_section2 .top-card,
  #section2-header .top-card {
    background-color: #324e96;
  }

  .coding {
    font-size: medium;
    text-align: center;
  }

  /*   #s2q1 {
    height: 771px;
  } */

  #s2q1 .reference img {
    width: 100%;
    height: auto;
  }

  .s2q1-width {
    max-width: 41px;
  }
  .s2q1-row-height {
    height: 36px;
  }

  .noWordWrap {
    white-space: nowrap;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }
}

@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .fixWidth {
    width: 80%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }

  .fixWidth {
    width: 80%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "section2",
  mixins: [bus_common],
  props: ["session", "sanwers2"],
  data() {
    return {
      bFirstUpdate: false,
      local_q15Form: {},
      local_s2answers: {},

      s2answers: {
        s2q1: "",
        s2q2: "",
        s2q3: "",
        s2q4: "",
        s2q5: "",
        s2q6: "",
        s2q7: "",
        s2q8: "",
        s2q9: "",
        s2q10: "",
        s2q11: "",
        s2q12: "",
        s2q13: "",
        s2q14: "",
        s2q15: "",
        s2q16: "",
      },
      search: "",
      /* pages: [
        { id: 1, pg: "0", src: "./question_images/s2q1.png" },
        { id: 2, pg: "5", src: "./question_images/s2q2.png" },
        { id: 3, pg: "8", src: "./question_images/s2q3.png" },
        { id: 4, pg: "9", src: "./question_images/s2q4.png" },
        { id: 5, pg: "9", src: "./question_images/s2q5.png" },
        { id: 6, pg: "15", src: "./question_images/s2q6.png" },
        { id: 7, pg: "15", src: "./question_images/s2q7.png" },
        { id: 8, pg: "8 & 9", src: "./question_images/s2q8.png" },
        { id: 9, pg: "8 & 9", src: "./question_images/s2q9.png" },
        { id: 10, pg: "8 & 9", src: "./question_images/s2q10.png" },
        { id: 11, pg: "8 & 9", src: "./question_images/s2q11.png" },
        {
          id: 12,
          pg: "Tiburon Screenshot",
          src: "./question_images/tiburon_screen_750.png",
        },
      ], */
      bReadyToUpdate: false,
    };
  },
  watch: {
    local_s2answers: {
      deep: true,
      handler() {
        this.update_answers();
      },
    },
    local_q15Form: {
      deep: true,
      handler() {
        this.update_answers();
      },
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    update_answers() {
      if (this.bReadyToUpdate) {
        this.$emit("update_answers", this.local_s2answers, this.local_q15Form);
      }
    },
    init() {
      this.local_s2answers = this.mno(this.sanwers2);

      this.$nextTick(() => {
        this.bReadyToUpdate = true;
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
